import { unsupportedBrowserMessages } from '../i18n/bootMessages'

export function hasRequiredBrowserFeatures() {
  return typeof Object.hasOwn === 'function' && typeof Array.prototype.at === 'function'
}

/** 先于 app/Sentry 导入，复用首屏壳展示；不启动不受支持的应用。 */
export function checkBrowserSupport() {
  if (hasRequiredBrowserFeatures()) return true
  const locale = location.protocol === 'capacitor:' ? 'en'
    : document.querySelector('meta[name="app-locale"]')?.getAttribute('content')
      || (import.meta.env.DEV ? import.meta.env.VITE_DEFAULT_LOCALE || 'zh' : '')
  const messages = unsupportedBrowserMessages[locale]
  if (!messages) throw new Error('Browser support screen requires deployment locale')
  document.querySelector('.app-boot__title').textContent = messages.title
  document.querySelector('.app-boot__hint').textContent = messages.hint
  document.querySelector('.app-boot').setAttribute('role', 'alert')
  return false
}
